import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { ApiService } from "../../../services/http/api.service";
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Component({
  selector: 'app-get-beats',
  templateUrl: './get-beats.component.html',
  styleUrls: ['./get-beats.component.scss']
})
export class GetBeatsComponent implements OnInit {

  beatsList: any = [];
  getPaginationCount = 0;
  page = 1;
  filteredDetails: any = {
    search_string:'',
    start_date:'',
    end_date:''
  };
  filteredDetailsForApi:any = {
    search_string:'',
    start_date:'',
    end_date:''
  };
  constructor(
    private router: Router,
    private apiConfig: ApiConfiguration,
    private apiService: ApiService,
    private toast: ToastClientService,
    private formateDate: DateFormateService
  ) { }

  ngOnInit() {
    this.getBeatsList(this.filteredDetailsForApi);
  }
  paginationClick(pageNumber) {
    this.page = pageNumber;
    this.filterListOfRecords();
  }
  selectedDates(dates){
    console.log(dates);
    if(dates.from){
      this.filteredDetailsForApi.start_date = this.formateDate.formateDate(dates.from);
    }
    if(dates.to){
      this.filteredDetailsForApi.end_date = this.formateDate.formateDate(dates.to);
    }
    if(!dates.from){
      this.filteredDetailsForApi.start_date = '';
    }
    if(!dates.to){
      this.filteredDetailsForApi.end_date = '';
    }
  }
  filterListOfRecords(){
    this.filteredDetailsForApi.search_string = this.filteredDetails.search_string;
    this.getBeatsList(this.filteredDetailsForApi);
  }
  getBeatsList(data){
    this.apiService.getHeaders(this.apiConfig.getVisits+'&page='+this.page+
    "&visit_beat_name="+data.search_string+'&from_date='+data.start_date+'&to_date='+data.end_date)
    .subscribe((res:any)=>{
      this.filteredDetailsForApi.start_date = '';
      this.filteredDetailsForApi.end_date = '';
      this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
      this.beatsList = res.body.data;

    },err=>{
      this.toast.Error('Error retreving beats list')
    })
  }

  viewVisits(beat){
    this.router.navigateByUrl('/hubAdmin/get-visits/' + beat.id);
  }
}
